<script lang="ts" setup>
	import {getProductDetailUrlForSubstitute} from '@/service/order.line.service';
	import {getPackingUnit, type Substitute} from 'dummen-shared';
	import type {ShoppingCartOrderLine} from 'dummen-shared/src/interfaces/order.line.type.ts';
	import ShoppingcartSubstituteOrderInput from '@/components/ShoppingcartSubstituteOrderInput.vue';

	const props = defineProps<{
		product: Substitute;
		region: string;
	}>();

	/**
	 * Convert the substitute product to a ShoppingCartOrderLine since the input requires it but mostly because this way
	 * we make sure that the inputs always receive the correct data in all places.
	 */
	const toShoppingCartOrderLine = (product: Substitute): ShoppingCartOrderLine => {
		return {
			amount: 0,
			articleId: product.patcode,
			articleName: product.name,
			consignment: null,
			formId: product.form?.patId,
			formName: product.form?.shortName,
			groupId: '',
			groupName: product.productgroup,
			image: product.image,
			locationId: product.location?.shortName ?? null,
			notExistingVariety: false,
			packingUnit: getPackingUnit(product.packingUnitPerCompanyId),
			region: props.region,
			urlFriendlyId: product.urlFriendlyId,
			urlFriendlyName: product.urlFriendlyName,
			urlFriendlyProductgroup: product.urlFriendlyProductgroup,
			week: product.week,
			year: product.year,
			preferredDeliveryDay: null,
			allowOverbooking: product.allowOverbooking,
			amountAvailable: product.availability,
			alternativeForms: [],
		};
	};

	const getDetailUrl = (): string | undefined => {
		return getProductDetailUrlForSubstitute(props.product, props.region);
	};

	const getProductImage = (): string => {
		if (props.product && props.product.image) {
			return props.product.image;
		}

		return '/assets/images/build/fallback-product-image.jpg';
	};
</script>

<template>
	<div class="substitute-variety--wrapper">
		<div class="substitute-variety--info">
			<a :href="getDetailUrl()" target="_blank">
				<img :src="getProductImage()"
				     alt="product"
				     data-pagespeed-no-transform
				     height="150"
				     width="160" />
			</a>
		</div>

		<div class="substitute-variety--title">
			<a target="_blank" v-bind:href="getDetailUrl()">{{ product.name }}</a>
		</div>

		<div class="substitute-variety--order">
			<shoppingcart-substitute-order-input :week="product.week"
			                                     :year="product.year"
			                                     :substitute="toShoppingCartOrderLine(product)"
			/>
		</div>
	</div>
</template>
